import { bindModalAction, createModalOverlay } from './modalBase';

interface ClearConfirmationOptions {
  onConfirm: () => void;
  skipKey: string;
}

export const showClearConfirmationModal = ({ onConfirm, skipKey }: ClearConfirmationOptions): void => {
  if (localStorage.getItem(skipKey) === 'true') {
    onConfirm();
    return;
  }

  const { overlay, close } = createModalOverlay(`
    <div class="modal-content">
      <h3 class="modal-title">Clear Canvas</h3>
      <p class="modal-message">Are you sure you want to clear everything? You can undo this action if needed.</p>
      <label class="modal-checkbox">
        <input type="checkbox" id="dont-show-again">
        Don't ask me again
      </label>
      <div class="modal-actions">
        <button class="modal-btn modal-btn-cancel">Cancel</button>
        <button class="modal-btn modal-btn-confirm">Clear</button>
      </div>
    </div>
  `);

  bindModalAction(overlay, '.modal-btn-cancel', close);
  bindModalAction(overlay, '.modal-btn-confirm', () => {
    const checkbox = overlay.querySelector('#dont-show-again') as HTMLInputElement | null;
    if (checkbox?.checked) {
      localStorage.setItem(skipKey, 'true');
    }
    close();
    onConfirm();
  });
};
